import AbstractComponent from "./abstract-component";

const createTemplate = () => {
  return (
    `<section class="main-page__section main-page__section--news">
      <div class="main-page__sectionWrap container">
        <div class="main-page__titleWrap">
          <h2 class="main-page__title">
            Новости
          </h2>
          <a class="main-page__link" href="/news">
            Смотреть все
          </a>
        </div>
        
        <div class="main-page__content swiper swiper--news">
          <ul class="main-page__list swiper-wrapper"></ul>

          <button class="main-page__swiperButton main-page__swiperButton--prev swiper__button swiper__button--prev" type="button" title="Предыдущий">
            Предыдущий
            <svg className="" width="10" height="10" aria-hidden="true">
              <use href="sienge/img/sprite.svg#arrow-small-left"></use>
            </svg>
          </button>

          <button class="main-page__swiperButton main-page__swiperButton--next swiper__button swiper__button--next" type="button" title="Следующий">
            Следующий
            <svg className="" width="10" height="10" aria-hidden="true">
              <use href="sienge/img/sprite.svg#arrow-small-right"></use>
            </svg>
          </button>
        </div>
      </div>
    </section>`
  );
};

export default class NewsListComponent extends AbstractComponent {
  getTemplate() {
    return createTemplate();
  }
}
